// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1Hb6y","ranges":"BmiRanges_ranges__3zqo8"};